import { configureStore } from "@reduxjs/toolkit";
import audioReducer from "./slices/audioSlice";
import audioDashboardReducer from "./slices/audioDashboardSlice";

export const store = configureStore({
  reducer: {
    audio: audioReducer,
    audioDashboard: audioDashboardReducer,
  },
});
